export function buildReleaseString(
  appName: string,
  version: string,
  gitSha?: string,
): string {
  const shaShort = gitSha ? gitSha.substring(0, 8) : '';
  return shaShort
    ? `${appName}@${version}+${shaShort}`
    : `${appName}@${version}`;
}

export function parseReleaseEnv(env: {
  APP_VERSION?: string;
  GIT_SHA?: string;
  appName?: string;
}): string {
  const version = env.APP_VERSION ?? '0.0.0';
  const sha = env.GIT_SHA;
  const app = env.appName ?? 'tovplus';
  return buildReleaseString(app, version, sha);
}
